import { render, staticRenderFns } from "./ExternalBlocked.vue?vue&type=template&id=a668e2e4&"
import script from "./ExternalBlocked.vue?vue&type=script&lang=js&"
export * from "./ExternalBlocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports